import React from 'react';
import type { SectionProps } from './types';

export const HeadlinesSection: React.FC<SectionProps> = ({ data, setFormData }) => (
  <div className="border-b pb-6">
    <h3 className="text-lg font-semibold text-gray-900 mb-4">Headlines</h3>

    <div className="space-y-4">
      <div>
        <label className="flex items-center space-x-2 mb-2">
          <input
            type="checkbox"
            checked={data.showHeadline || false}
            onChange={e => setFormData({ ...data, showHeadline: e.target.checked })}
            className="w-4 h-4 text-primary-600 border-gray-300 rounded-md focus:ring-primary-500"
          />
          <span className="text-sm font-medium text-gray-700">Show Headline</span>
        </label>
        {data.showHeadline && (
          <textarea
            value={data.headline || ''}
            onChange={e => setFormData({ ...data, headline: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500 mt-2"
            rows={2}
            placeholder="Enter headline (press Enter for line break)"
          />
        )}
      </div>

      <div>
        <label className="flex items-center space-x-2 mb-2">
          <input
            type="checkbox"
            checked={data.showSubheadline || false}
            onChange={e => setFormData({ ...data, showSubheadline: e.target.checked })}
            className="w-4 h-4 text-primary-600 border-gray-300 rounded-md focus:ring-primary-500"
          />
          <span className="text-sm font-medium text-gray-700">Show Subheadline</span>
        </label>
        {data.showSubheadline && (
          <textarea
            value={data.subheadline || ''}
            onChange={e => setFormData({ ...data, subheadline: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500 mt-2"
            rows={2}
            placeholder="Enter subheadline (press Enter for line break)"
          />
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Headline Alignment</label>
          <select
            value={data.headlineAlignment || 'center'}
            onChange={e => setFormData({ ...data, headlineAlignment: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
          >
            <option value="left">Left</option>
            <option value="center">Center</option>
            <option value="right">Right</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Headline Size</label>
          <select
            value={data.headlineSize || 'medium'}
            onChange={e => setFormData({ ...data, headlineSize: e.target.value })}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary-500 focus:border-primary-500"
          >
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
          </select>
        </div>
      </div>
    </div>
  </div>
);
